import React from 'react'
// import { FaPlus } from 'react-icons/fa'
// import { Link } from 'react-router-dom'
import ServiceCard from './ServiceCard'
import { useTranslation } from 'react-i18next'
const ServiceAreaGroupFive = () => {
  const { t } = useTranslation()

  const slider = t('services-slider', { returnObjects: true })
  return (
    <>
      {/* service area start */}
      <div id="services" className="service-area bg-relative pd-top-120">
        <div className="container">
          <div className="row">
            {slider.map((service) => (
              <ServiceCard
                key={service.id}
                title={service.title}
                icon={service.icon}
                id={service.id}
                description={service.description}
              />
            ))}
          </div>
        </div>
      </div>
      {/* service area end */}
    </>
  )
}

export default ServiceAreaGroupFive
